import { tutoresApi, wompiPagosApi } from '../../services/api';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { isProduction } from '../../config/constants';

export const useWompiModel = () => {
  const [infoPago, settransaccion] = useState();
  const [loadingtransaccion, setLoadingtransaccion] = useState(true);
  const [errortransaccion, setErrortransaccion] = useState();

  const urlBase = isProduction ? 'https://production.wompi.co/v1/transactions' : 'https://sandbox.wompi.co/v1/transactions';

  //obtener firma para pago wompi
  const obtenerFirmaIntegridad = async(referencia,montoEnCentavos) =>{
    try{
      console.log("obtener firma integrdidad",referencia,montoEnCentavos);
      const response = await wompiPagosApi.obtenerFirmaIntegral(referencia,montoEnCentavos);
      return response;
    }
    catch(error){
      console.error("Error obteniendo firma:", error);
      return null;
    }
  }

  //obtener pago de wompi
  const obtenerTrasaccion = async(idTransaccion) =>{
    try{
      console.log("obtener transaccion obtenerTrasaccion");
      setLoadingtransaccion(true);
      setErrortransaccion(null);

      const resWompi = await axios.get(`${urlBase}/${idTransaccion}`);
      console.log("transaccion obtenida",resWompi);
      const pago = resWompi.data.data;
      settransaccion(pago);

    }
    catch(error){
      console.error("Error de transaccion",error);
      setErrortransaccion('Error al cargar la transaccion: ' + error.message);
    }
    finally{
      setLoadingtransaccion(false);
    }

  }

  return{
    obtenerFirmaIntegridad,
    obtenerTrasaccion,

    infoPago,
    loadingtransaccion,
    errortransaccion,
  }

}